import ms from 'ms'
import { motionValue } from 'framer-motion'

export const pointerX = motionValue(0)
export const pointerY = motionValue(0)
export const pointerEngaged = motionValue(0)

const IDLE_MS = ms('3s')

export const GAZE_RANGE_PX = 300
export const GAZE_RELEASE_PX = 340

export const GAZE_MAX_X = 3.25
export const GAZE_MAX_Y = 3

let subscribers = 0
let idleTimer = 0

function disengage() {
  window.clearTimeout(idleTimer)
  pointerEngaged.set(0)
}

function onPointerMove(event: PointerEvent) {
  pointerX.set(event.clientX)
  pointerY.set(event.clientY)
  pointerEngaged.set(1)
  window.clearTimeout(idleTimer)
  idleTimer = window.setTimeout(disengage, IDLE_MS)
}

function onPointerOut(event: PointerEvent) {
  if (event.relatedTarget instanceof Node) {
    return
  }
  disengage()
}

export function subscribePointerTracking() {
  subscribers += 1
  if (subscribers === 1) {
    window.addEventListener('pointermove', onPointerMove, { passive: true })
    window.addEventListener('pointerout', onPointerOut)
    window.addEventListener('blur', disengage)
  }

  return () => {
    subscribers -= 1
    if (subscribers > 0) {
      return
    }
    window.removeEventListener('pointermove', onPointerMove)
    window.removeEventListener('pointerout', onPointerOut)
    window.removeEventListener('blur', disengage)
    disengage()
  }
}

export function axisOffset(delta: number, distance: number, max: number) {
  if (distance === 0 || distance > GAZE_RELEASE_PX) {
    return 0
  }
  const strength = Math.min(distance / GAZE_RANGE_PX, 1)
  return (delta / distance) * max * strength
}
